import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { uuidv4 } from '@epihub/core/src/fn/uuidv4';
import { safelyWait } from '@epihub/core/src/fn/safely';
import { log } from '../_ctx/log';

async function getVisitorIdFromFingerprintJS() {
  const cached = localStorage.getItem('fingerprintVisitorId');
  if (cached) {
    log.i('fingerprint::getVisitorIdFromFingerprintJS', `using cached visitorId=(${cached})`);
    return cached;
  }

  const fp = await FingerprintJS.load({
    // @ts-ignore the docs use this https://github.com/fingerprintjs/fingerprintjs/blob/master/docs/api.md#webpackrollupnpmyarn
    // but it's not in types
    monitoring: false,
  });
  const result = await fp.get();
  localStorage.setItem('fingerprintVisitorId', result.visitorId);
  log.i('fingerprint::getVisitorIdFromFingerprintJS', `got visitorId=(${result.visitorId})`);
  return result.visitorId;
}

function getVisitorIdFromLocalStorage() {
  const visitorId = localStorage.getItem('visitorId') ?? uuidv4();
  localStorage.setItem('visitorId', visitorId);
  log.i('fingerprint::getVisitorIdFromLocalStorage', `got visitorId=(${visitorId})`);
  return visitorId;
}

export async function getVisitorId() {
  return safelyWait(
    () => getVisitorIdFromFingerprintJS(),
    (error) => {
      log.w('getVisitorId', 'failed to get visitorId from FingerprintJS', { error });
      return getVisitorIdFromLocalStorage();
    },
  );
}
